type LocationDetails = {
  placeId: string;
  fullAddress: string;
  streetNumber?: string;
  route?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  coordinates: {
    latitude: number | null;
    longitude: number | null;
  };
}

export const extractAddress = (results: google.maps.GeocoderResult[]): LocationDetails | null => {
  if (!results || results.length === 0) return null

  const firstResult = results[0]
  const addressComponents = firstResult.address_components
  const geometry = firstResult.geometry.location

  // Create an object to store extracted information
  const details: LocationDetails = {
    placeId: firstResult.place_id,
    fullAddress: firstResult.formatted_address,
    coordinates: {
      latitude: geometry.lat(),
      longitude: geometry.lng(),
    },
  }

  // Extract specific address components
  addressComponents.forEach(component => {
    const types = component.types

    if (types.includes('street_number')) {
      details.streetNumber = component.long_name
    }

    if (types.includes('route')) {
      details.route = component.long_name
    }

    if (types.includes('locality')) {
      details.city = component.long_name
    }

    if (types.includes('administrative_area_level_1')) {
      details.state = component.long_name
    }

    if (types.includes('country')) {
      details.country = component.long_name
    }

    if (types.includes('postal_code')) {
      details.postalCode = component.long_name
    }
  })

  return details
}
